import { useMemo } from 'react';
import { useGetSmartLinksQuery } from '../../../redux/api/fymAPI';
import { isSmartLinkDraft } from '../../smartLinks/utils/isSmartLinkDraft';

/** One page is enough to name the top pages and count the live ones of nearly every artist. */
const HOME_SMART_LINKS_LIMIT = 100;

export interface HomeSmartLinks {
  /** Every page of the artist, drafts too. `undefined` while it loads. */
  total: number | undefined;
  liveCount: number;
  /** The page name by smartlink id: the published name, else the draft name. */
  nameById: Map<number, string>;
  isLoading: boolean;
}

/** The artist's smartlinks, for the "N live pages" line, the top pages and the empty state. */
export function useHomeSmartLinks(accountId: number): HomeSmartLinks {
  const { data, isLoading } = useGetSmartLinksQuery({ accountId, page: 0, limit: HOME_SMART_LINKS_LIMIT });

  return useMemo(() => {
    const results = data?.results ?? [];
    return {
      total: data?.totalItems,
      liveCount: results.filter((smartLink) => !isSmartLinkDraft(smartLink)).length,
      nameById: new Map(
        results.map((smartLink) => [
          smartLink.id,
          smartLink.publishedSmartLinkVersion?.name ?? smartLink.recentSmartLinkVersion.name,
        ])
      ),
      isLoading,
    };
  }, [data, isLoading]);
}
